import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default (Alpine) => {
  Alpine.data('loyaltySlider', () => ({
    swiper: null,
    loyaltyTier: null,
    resizeHandler: null,

    init() {
      this._pollForLoyaltyTier();
      this._initSwiper();

      this.resizeHandler = () => this._resized();
      window.addEventListener('resize', this.resizeHandler);

      this._resized();
    },

    destroy() {
      this._destroySwiper();

      if (this.resizeHandler) {
        window.removeEventListener('resize', this.resizeHandler);
      }
    },

    setCurrentTier(loyaltyTier) {
      console.log('setting tier', window.swellConfig)
      const tier = loyaltyTier;
      if (!tier) return;

      const tierElement = this.$refs.slider.querySelector(`[data-tier="${tier}"]`);
      if (tierElement) {
        const badgeEl = document.createElement('div');
        badgeEl.classList.add('tier-badge');
        badgeEl.textContent = 'CURRENT STATUS';
        tierElement.appendChild(badgeEl);
      }
    },

    _pollForLoyaltyTier() {
      const maxTries = 30;
      let tries = 0;

      const interval = setInterval(() => {
        tries++;

        const vipTier = window.swellConfig?.customer?.vip_tier?.name;

        if (vipTier) {
          clearInterval(interval);
          this.loyaltyTier = vipTier;
          this.setCurrentTier(vipTier);
        }

        if (tries >= maxTries) {
          clearInterval(interval);
        }
      }, 1000);
    },

    _resized() {
      if (window.innerWidth >= 1024) {
        this._destroySwiper();
      } else {
        this._initSwiper();
      }
    },

    _initSwiper() {
      if (this.swiper) return;

      this.swiper = new Swiper(this.$refs.slider, {
        slidesPerView: 2,
        spaceBetween: 0,
        loop: false,
        initialSlide: 0,
        slidesPerGroup: 2,
        modules: [Navigation, Pagination],
        navigation: {
          nextEl: document.querySelector('.loyalty-nav .swiper-button-next'),
          prevEl: document.querySelector('.loyalty-nav .swiper-button-prev'),
        },
        pagination: {
          el: document.querySelector('.loyalty-nav .swiper-pagination'),
          clickable: true,
        },
      });
    },

    _destroySwiper() {
      if (!this.swiper) return;

      this.swiper.destroy(true, true);
      this.swiper = null;
    },
  }));
};